import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const  Interceptors = () => {
    const navigate = useNavigate();
    axios.interceptors.request.use(function (config) {
        const token = localStorage.getItem('jwt');
        config.headers.set('Authorization', token);
        return config;
    });
    axios.interceptors.response.use(function (response) {
            if (response?.data?.tokenExpired) {
                localStorage.removeItem('jwt');
                navigate('/login');
            }
            return response;
        },
        (error) => {
            if (!error?.response?.data?.tokenExpired) {
                toast.error(error?.response?.data?.msg || 'There was an unexpected error');
            }
        });
}
export default Interceptors;